<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="mw-970 mx-auto">
                    <div class="c-section">
                        <div class="d-md-flex align-items-center justify-content-between">
                            <h2 class="c-ttl c-ttl--mdp fw-b">Luggage and supplements</h2>

                            <button class="btn btn-white-alt-sec is-smaller txt-init mt-3 mt-md-0" @click="skip()">Continue without luggage and supplements</button>
                        </div>

                        <booking-luggage v-if="luggageInfo.extra"></booking-luggage>

                        <booking-supplement v-for="supplement in availableSupplements" v-bind:key="supplement.id" :supplement="supplement"></booking-supplement>

                        <div class="d-md-flex align-items-center justify-content-between mt-4 pt-2">
                            <button type="button" class="btn btn-white-alt-sec bg-white is-wide mr-3 mb-3" @click="previousStep">Back</button>
                            <button class="btn btn-primary is-wide mb-3" @click="submit()">Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import BookingLuggage from './BookingLuggage'
import BookingSupplement from './BookingSupplement'

export default {
    components: {
        BookingLuggage,
        BookingSupplement,
    },
    mounted() {
        this.$scrollTo('body')

        this.track({
            event: 'supplements_and_luggage'
        })
    },
    computed: {
        ...mapState('booking', [
            'luggageInfo',
            'availableSupplements',
        ]),
    },
    methods: {
        ...mapActions('booking', [
            'previousStep',
            'nextStep',
            'updateBooking',
        ]),
        submit() {
            this.updateBooking(['luggage', 'supplements'])
        },
        skip() {
            this.$store.commit('booking/removeSupplements')
            this.$store.commit('booking/removeLuggage')
            this.submit()
        }
    }
}
</script>